query PlayerParamfindingResultsByEvent($eventId: UUID!) {
  allPlayerParamfindingResults(filter: {eventId: {equalTo: $eventId}}) {
    nodes {
      eventId
      eventStateFeed
      playerSummaries
      sport
      timestamp
    }
  }
}
